import React, { Fragment } from 'react';
import { Radio } from 'tea-component';
import { useIntl } from 'umi';
import BubbleCommon, {
  topicExcludeContainFilterTips,
  topicExcludeOnlyContainFilterTips,
  topicIncludeContainFilterTips,
  topicIncludeOnlyContainFilterTips,
} from '../../../BubbleCommon';

type TTopicRule = 'include' | 'exclude' | 'only_include' | 'only_exclude';

interface ContentHeaderProps {
  topicRule: TTopicRule;
  setTopicRule: any;
  topicGroupValue: 'include' | 'exclude';
  hasHeaderContent?: boolean;
  isCategoryTab?: boolean; // 是否为 Category Tab，Category Tab 不显示 Include/Exclude 按钮
}

export default function ContentHeader({
  topicRule,
  setTopicRule,
  topicGroupValue,
  hasHeaderContent,
  isCategoryTab = false,
}: ContentHeaderProps) {
  const { formatMessage } = useIntl();

  if (!hasHeaderContent) return null;

  // Category Tab 不显示 Include/Exclude 按钮
  if (isCategoryTab) return null;

  return (
    <div className="dbo-topic-region">
      <Radio.Group
        value={topicGroupValue}
        onChange={(value) => setTopicRule(value)}
      >
        {[
          {
            text: 'Include',
            value: 'include',
            options: [
              {
                text: 'Contain',
                value: 'include',
                tips: topicIncludeContainFilterTips,
              },
              {
                text: 'Only Contain',
                value: 'only_include',
                tips: topicIncludeOnlyContainFilterTips,
              },
            ],
          },
          {
            text: 'Exclude',
            value: 'exclude',
            options: [
              {
                text: 'Contain',
                value: 'exclude',
                tips: topicExcludeContainFilterTips,
              },
              {
                text: 'Only Contain',
                value: 'only_exclude',
                tips: topicExcludeOnlyContainFilterTips,
              },
            ],
          },
        ].map(({ text, value, options }) => {
          return (
            <Fragment key={value}>
              <Radio name={value}>{formatMessage({ id: text })}</Radio>
              {topicGroupValue === value && (
                <div className="dbo-topic-region-tab">
                  {options.map(({ text, value: ruleValue, tips }) => (
                    <BubbleCommon
                      tipsMap={tips}
                      placement="top"
                      showIcon={false}
                      key={ruleValue}
                    >
                      <div
                        onClick={() => setTopicRule(ruleValue)}
                        className={`dbo-topic-region-item ${
                          ruleValue === topicRule ? 'active' : ''
                        }`}
                      >
                        {formatMessage({ id: text })}
                      </div>
                    </BubbleCommon>
                  ))}
                </div>
              )}
            </Fragment>
          );
        })}
      </Radio.Group>
    </div>
  );
}
